import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Form, Control, Errors} from 'react-redux-form';
import DatePick from "./../forms/datepicker";
import BigFileUpload from "../widgets/big_file_upload";
import _ from "lodash";
import {isRequired, required, isEmail, email, phoneNumber} from "../field_validations";
import {toInt} from "../parsers";
import Loading from "../loading";

const propTypes = {
	owner: PropTypes.object.isRequired,
	instance: PropTypes.object.isRequired,
	permissions: PropTypes.array.isRequired,
	saveAgency: PropTypes.func.isRequired
}

class InstanceEditForm extends Component {
	render() {
		const {entities, municipalities, match, owner, instance, fetching, disabled, permissions, modalities} = this.props;
		let instanceRev = instance.revision ? instance.revision.body : undefined;
		let modality = _.find(modalities.list, {slug: match.params.modality});
		let pc = _.find(permissions, (o) => {return o==='Create'});
		console.log(this.props);
		return (<div className="columns">
				<div className="column">
					{(instanceRev && !_.isEmpty(instanceRev.comment)) &&
					<div className={`message ${instanceRev.status ? 'is-'+instanceRev.status : ''}`}>
						<div className="message-header">Comentarios</div>
						<div className="message-body">
							<p>{instanceRev.comment}</p>
						</div>
					</div>}

					<Form model="project.instance.data" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')} encType="multipart/form-data">

						<div className="field is-grouped">
							<div className={`control is-expanded ${fetching && ' is-loading'}`}>
								<label htmlFor="name" className="label">Nombre de la instancia <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".name"
									id="name"
									autoFocus
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Nombre de Instancia" errors={{isRequired}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".name"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'El nombre de la instancia es obligatorio'}}
								/>
							</div>

							<div className={`control ${fetching && ' is-loading'}`}>
								<label htmlFor="creation_date" className="label">Fecha de creación <span className="small has-text-danger">*</span></label>
								<Control
									model=".creation_date"
									errors={{isRequired}}
									validateOn="change"
									id="creation_date"
									value={instance.data && instance.data.creation_date ? instance.data.creation_date:''}
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									component={DatePick}
									disabled={fetching || disabled}
								/>
								<Errors
									model=".creation_date"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La fecha de creación es obligatoria'}}
								/>
							</div>
						</div>

						<div className="field">
							<div className={`control is-expanded${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="legal_nature" className="label">Naturaleza jurídica <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".legal_nature"
									id="legal_nature"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Naturaleza jurídica"
									errors={{isRequired}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".legal_nature"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La naturaleza jurídica de la instancia es obligatorio'}}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control ${fetching && 'is-loading'}`}>
								<label htmlFor="management_period_start" className="label">Inicio de gestión</label>
								<Control
									model=".management_period_start"
									id="management_period_start"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									value={instance.data && instance.data.management_period_start ? instance.data.management_period_start:''}
									errors={{isRequired}}
									validateOn="change"
									component={DatePick}
									disabled={fetching || disabled}
								/>
								<Errors
									model=".management_period_start"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La fecha de inicio de gestión es obligatoria'}}
								/>
							</div>

							<div className={`control ${fetching && 'is-loading'}`}>
								<label htmlFor="management_period_end" className="label">Fin de gestión</label>
								<Control
									model=".management_period_end"
									id="management_period_end"
									value={instance.data && instance.data.management_period_end ? instance.data.management_period_end:''}
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									errors={{isRequired}}
									validateOn="change"
									component={DatePick}
									disabled={fetching || disabled}
								/>
								<Errors
									model=".management_period_end"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La fecha de fin de gestión es obligatoria'}}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control is-expanded${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="street" className="label">Dirección <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".street"
									id="street"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Calle" errors={{isRequired}} validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".street"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La dirección es obligatoria'}}/>
							</div>

							<div className={`control${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="num_ext" className="label">Número <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".num_ext"
									id="num_ext"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									errors={{isRequired}}
									validateOn="change"
									placeholder="Número exterior"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".num_ext"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'El número exterior es obligatorio'}}
								/>
							</div>

							<div className={`control${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="num_int" className="label">Interior </label>
								<Control.text
									model=".num_int"
									type="text"
									id="num_int"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Número interior"
									disabled={fetching || disabled}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control is-expanded${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="colony" className="label">Colonia <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".colony"
									id="colony"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Colonia o Localidad"
									errors={{isRequired}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".colony"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{isRequired: 'La colonia es obligatoria'}}
								/>
							</div>

							<div className={`control${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="cp" className="label">Código postal <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".cp"
									id="cp"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									type="number"
									max="99999"
									step="1"
									min="1"
									placeholder="55555"
									errors={{required}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".cp"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{required: 'El código postal es obligatorio'}}
								/>
							</div>

							<div className={`control${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="road_type" className="label">Tipo de vialidad </label>
								<Control.text
									model=".road_type"
									id="road_type"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Tipo de Vialidad"
									disabled={fetching || disabled}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control`}>
								<label htmlFor="state" className="label">Estado <span className="small has-text-danger">*</span></label>
								<div className={`select ${instanceRev && 'is-'+instanceRev.status}`}>
									<Control.select
										model=".state_id"
										id="state"
										changeAction={(model, value) => this.changeMuns(model, value)}
										parser={toInt}
										errors={{required}}
										validateOn="change"
										disabled={fetching || disabled}>
											<option defaultValue={entities.isFetching}>--- Estado ---</option>
											{entities.list.map((option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
									</Control.select>
								</div>
								<Errors
									model=".state_id"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{required: 'El estado es obligatorio'}}
								/>
							</div>

							<div className="control">
								<label htmlFor="municipality" className="label">Municipio <span className="small has-text-danger">*</span></label>
								<div className={`select ${(municipalities.isFetching || fetching) && 'is-loading'}`}>
									<Control.select
										model=".municipality_id"
										id="municipality"
										errors={{required}}
										validateOn="change"
										disabled={_.size(municipalities.list) < 0 || fetching || disabled || municipalities.isFetching}>
											<option value="" defaultValue>--- Municipio ---</option>
											{municipalities.list.map((option, key) => {
												return <option key={key} value={option.id}>{option.name}</option>
											})}
									</Control.select>
								</div>
								<Errors
									model=".municipality_id"
									show="touched"
									wrapper={(props) => <small
									className="help has-text-danger">{props.children}</small>}
									messages={{required: 'El municipio o delegación es obligatorio'}}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control is-expanded${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="telephone" className="label">Teléfono principal <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".telephone"
									id="telephone"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Teléfono principal"
									errors={{isRequired, phoneNumber}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".telephone"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{
										isRequired: 'El teléfono es obligatorio',
										phoneNumber: 'El número de teléfono es inválido'
									}}
								/>
							</div>

							<div className={`control is-expanded${fetching ? ' is-loading' : ''}`}>
								<label htmlFor="telephone_2" className="label">Teléfono alterno</label>
								<Control.text
									model=".telephone_2"
									id="telephone_2"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Teléfono alterno"
									errors={{phoneNumber}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".telephone_2"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{
										phoneNumber: 'El número de teléfono es inválido'
									}}
								/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className={`control is-expanded ${fetching && 'is-loading'}`}>
								<label htmlFor="email" className="label">Email principal <span className="small has-text-danger">*</span></label>
								<Control.text
									model=".email"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Email principal"
									errors={{isRequired, isEmail}}
									validateOn="change"
									disabled={fetching || disabled}
								/>
								<Errors
									model=".email"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{
										isRequired: 'El email principal es obligatorio',
										isEmail: 'El email es inválido'
									}}
								/>
							</div>

							<div className={`control is-expanded ${fetching && 'is-loading'}`}>
								<label htmlFor="email_2" className="label">Email secundario </label>
								<Control.text
									model=".email_2" id="email_2"
									className={`input ${instanceRev !== undefined && 'is-'+instanceRev.status}`}
									placeholder="Email secundario"
									errors={{email}}
									validateOn="change"
									disabled={disabled}
								/>
								<Errors
									model=".email_2"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{
										email: 'El email es inválido'
									}}
								/>
							</div>
						</div>

						<hr />
						<h4 className="title is-5">Documentación</h4>
						<div className="hero is-light">
							<div className="hero-body">
								{!fetching &&
								<div className="field">
									{this.validateOwner(owner, instance.data.name) ?
										<div className={`control`}>
											<a onClick={() => this.props.projectAgencyExport(match.params.modality, match.params.state, match.params.municipality)}>
												Generar solicitud de participación
												<i className="fa fa-external-link" aria-hidden="true"/>
											</a>
										</div> :
										<p className="tag is-warning">
											Los datos del titular y el nombre de la Instancia no están completos y son requeridos para generar la solicitud de participación.
										</p>
									}
								</div>}

								{fetching ? <Loading/>:
									<div className="field is-grouped is-grouped-multiline is-grouped-left">
										{_.map(_.filter(instance.documents_items, (o) => {return o.agency_type === null && (o.modality_id === null || o.modality_id === (modality ? modality.id:undefined))}),(item, d) => {
											let documentRev =!_.isEmpty(instanceRev) ? _.find(instanceRev, {field: item.slug}):undefined;
											let accepts = undefined;
											_.map(item.documents_types, (ext) => {
												accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
											})
											console.log(item);
											return (
												<BigFileUpload
													key={d}
													model={`.${item.slug}`}
													name={item.name}
													file={instance.data && instance.data[item.slug]}
													file_format={item.file_format}
													accept={accepts}
													comment={documentRev && documentRev.comment ? documentRev.comment:undefined}
													status={documentRev && documentRev.status}
													disabled={this._blockFields(item.slug)}
												/>
											)
										})}
									</div>}
							</div>
						</div>

						{(match.params.modality === 'modalidad-ii') &&
							[<hr key="extra-docs-bar" />,
							<h5 className="title is-5" style={{marginTop: '30px'}} key="extra-docs-title">Documentación adicional</h5>,
							<div className="hero is-light" key="extra-docs-info">
								<div className="hero-body">
									<div className="field">
										<div className="control">
											<label htmlFor="type" className="label">Tipo de Instancia <span className="small has-text-danger">*</span></label>
											<div className={`select${fetching ? ' is-loading' : ''}`}>
												<Control.select model=".type"
												                id="type"
												                disabled={disabled || fetching}
												                validateOn="change"
												                errors={{isRequired}}
												                changeAction={(model, value) => this._changeType(model, value)}>
													<option value="" defaultValue>--- Tipo de Instancia ---</option>
													<option value="centralized">Centralizada</option>
													<option value="decentralized">Descentralizada</option>
													<option value="delegacy">Delegación</option>
												</Control.select>
											</div>
											<Errors
												model=".type"
												show="touched"
												wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
												messages={{isRequired: 'Favor de seleccionar el tipo de instancia'}}
											/>
										</div>
									</div>

									{fetching ? <Loading/>:
										<div className="field is-grouped is-grouped-multiline is-grouped-left">
											{_.map(_.filter(instance.documents_items, (o) => {return o.agency_type === instance.data.type && o.modality_id === (modality ? modality.id:undefined)}),(item, d) => {
												let documentRev =!_.isEmpty(instanceRev) ? _.find(instanceRev, {field: item.slug}):undefined;
												let accepts = undefined;
												_.map(item.documents_types, (ext) => {
													accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
												})
												return (
													<BigFileUpload
														key={d}
														model={`.${item.slug}`}
														name={item.name}
														file={instance.data && instance.data[item.slug]}
														file_format={item.file_format}
														accept={accepts}
														comment={documentRev && documentRev.comment ? documentRev.comment:undefined}
														status={documentRev && documentRev.status}
														disabled={this._blockFields(item.slug)}
													/>
												)
											})}
										</div>}
								</div>
							</div>]}
						<br/>
						<div className="field is-grouped is-grouped-right" style={{marginTop: '30px'}}>
							<div className="control">
								<button type="button" className="button is-large" disabled={fetching} onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{pc ?
							<div className="control">
								<Control.button
									model="project.instance"
									className="button is-primary is-large"
									disabled={disabled}>
									Guardar
								</Control.button>
							</div>:''}
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			agencyType: null,
			cleanForm: true
		}
	}

	_handleSubmit(values) {
		const {state, municipality, modality} = this.props.match.params;
		this.props.saveAgency(modality, state, municipality, values);
	}

	validateOwner(owner, instance) {
		console.log(owner);
		console.log(instance);
		if (owner) {
			if (owner.name && owner.last_name && owner.rfc && owner.curp && instance) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	changeMuns(model, value) {
		if (value) {
			this.props.fetchMunicipalities(value);
			this.props.change(model, value);
		}
	}

	_changeType(model, value) {
		this.props.change(model,value);
		const {instance, modalities, match} = this.props;
		let modality = _.find(modalities.list, {slug: match.params.modality});

		_.map(_.filter(instance.documents_items, (o) => {return o.agency_type === instance.data.type && o.modality_id === (modality ? modality.id:undefined)}),(item) => {
			this.props.change(`project.instance.data.${item.slug}`, undefined);
		})

		switch (value) {
			case 'decentralized':
				this.setState({agencyType: 'decentralized'});
				break;
			case 'centralized':
				this.setState({agencyType: 'centralized'});
				break;
			case 'delegacy':
				this.setState({agencyType: 'delegacy'});
				break;
			default:
				this.setState({agencyType: null});
				break;
		}
	}

	_blockFields(field) {
		let { instance } = this.props;
		let response = false;
		let editable = instance.editable;
		let instanceRevision = !_.isEmpty(instance.revision) ? instance.revision.body : undefined;
		console.log(instance);
		console.log(instanceRevision);
		if(!_.isEmpty(instanceRevision) && !instance.isFetching){
			console.log({allow_edit: 'true', field: field});
			let allow = _.find(instanceRevision, {allow_edit: 'true', field: field}) ? true : false;
			console.log(allow);
			if(editable && allow){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !instance.isFetching){
			response = false;
		}else {
			response = true;
		}

		return response;
	}
}

InstanceEditForm.propTypes = propTypes;

export default InstanceEditForm;


// WEBPACK FOOTER //
// ./src/elements/project/instance.jsx